import EventEmitter from 'eventemitter3';

const eventEmitter = new EventEmitter();

export type EventListener = (...args: unknown[]) => void;

interface EmitterInterface {
  on: (event: string, fn: EventListener) => EventEmitter;
  once: (event: string, fn: EventListener) => EventEmitter;
  off: (event: string, fn: EventListener) => EventEmitter;
  emit: (event: string, payload?: unknown) => boolean;
  listeners: (event: string) => EventListener[];
  removeAllListeners: (event?: string) => EventEmitter;
  removeListener: (event: string, fn: EventListener) => EventEmitter;
  listenerCount: (event: string) => number;
  eventNames: () => (string | symbol)[];
}

const Emitter: EmitterInterface = {
  on: (event: string, fn: EventListener) => eventEmitter.on(event, fn),
  once: (event: string, fn: EventListener) => eventEmitter.once(event, fn),
  off: (event: string, fn: EventListener) => eventEmitter.off(event, fn),
  emit: (event: string, payload?: unknown) => eventEmitter.emit(event, payload),
  listeners: (event: string) => eventEmitter.listeners(event) as EventListener[],
  removeAllListeners: (event?: string) => eventEmitter.removeAllListeners(event),
  removeListener: (event: string, fn: EventListener) => eventEmitter.removeListener(event, fn),
  listenerCount: (event: string) => eventEmitter.listenerCount(event),
  eventNames: () => eventEmitter.eventNames(),
};

Object.freeze(Emitter);

export default Emitter;
